import mixpanel from "mixpanel-browser";
import { useEffect, useState } from "react";

export enum MixPanelEventEnum {
    LOGIN = "login",
    REGISTER = "register",
    GAME_CREATED = "game_created",
    EVENT_CREATED = "event_created",
    ENTRY_CREATED = "entry_created",
    EVENT_RESOLVED = "event_resolved",
    EVENT_PUBLISHED = "event_published",
    WIDGET_READY = "widget_ready",
    PLAY_BUTTON_PRESSED = "play_button_pressed",
    MAKE_PICK_SCREEN_VIEWED = "make_pick_screen_viewed",
    REVIEW_PICKS_SCREEN_VIEWED = "review_picks_screen_viewed",
    PICK_OVERVIEW_SCREEN_VIEWED = "pick_overview_screen_viewed",
    UNAUTHED_OVERVIEW_SCREEN_VIEWED = "unauthenticated_overview_screen_viewed",
}

export const useMixpanel = (eventToTrack: string, eventId?: number): void => {
    const [lastEventId, setLastEventId] = useState(-1);
    useEffect(() => {
        if (eventId && eventId !== lastEventId) {
            mixpanel.track(
                eventToTrack,
                eventId
                    ? {
                          freeplay_event_id: eventId,
                      }
                    : undefined,
            );
            setLastEventId(eventId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventId]);
};
